import { Companion_getInstance1wcuorfuztxv3 as Companion_getInstance } from '../../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  writer1eia5its2a1fh as writer,
  writeFully3k1eaua3t4bqd as writeFully,
} from '../../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { SafeContinuation1x0fxyaxo6cwq as SafeContinuation } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/SafeContinuationJs.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { asByteArray281a45t1cr5zc as asByteArray } from '../ReadableStream.mjs';
import { awaitxmqwgrq6yfmw as await_0 } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readBodyBrowser(_this__u8e3s4, response) {
  var tmp0_elvis_lhs = response.body;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Companion_getInstance().t4n_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stream = tmp;
  return channelFromStream(_this__u8e3s4, stream);
}
function channelFromStream(_this__u8e3s4, stream) {
  return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda(stream)).p4n_1;
}
function *readChunk(_this__u8e3s4, $completion) {
  // Inline function 'kotlin.coroutines.suspendCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var c = $completion;
    var safe = SafeContinuation().id(intercepted(c));
    var continuation = safe;
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then((it) => {
      var chunk = it.value;
      var result = it.done ? null : chunk;
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(result);
      this_0.sc(tmp$ret$5);
      return Unit_instance;
    });
    tmp_0.catch((cause) => {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(cause));
      this_0.sc(tmp$ret$7);
      return Unit_instance;
    });
    return safe.jd();
  };
}
function channelFromStream$slambda$lambda(it) {
  return Unit_instance;
}
function channelFromStream$slambda($stream) {
  return constructCallableReference(($this$writer, $completion) => orPromise($completion, function *($completion) {
    var reader = $stream.getReader();
    var tmp;
    try {
      $l$loop: while (true) {
        var tmp0_elvis_lhs = yield* /*#__NOINLINE__*/readChunk(reader, $completion);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var chunk = tmp_0;
        yield* writeFully($this$writer.z4n_1, asByteArray(chunk), VOID, VOID, $completion);
        yield* $this$writer.z4n_1.a4n($completion);
      }
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var cause = $p;
        var tmp_2 = reader.cancel(cause);
        yield* await_0(tmp_2.catch(channelFromStream$slambda$lambda), $completion);
        throw cause;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  readBodyBrowser as readBodyBrowser2vmfk0na3k29n,
};
//endregion

//# sourceMappingURL=BrowserFetch.mjs.map
